<template>
  <div>
    <h2>Assets History {{ this.customAssetId }}</h2>
      <button
          @click="goBack"
      >
        <i class="fas fa-undo"></i>
        Back
      </button>
    <table>
      <thead>
      <tr class="header_history">
        <th class="text-center" v-for="header in tableHistoryHeaders">
          {{header.name}}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr style="border-bottom: 2px solid #cccccc !important"
          v-for="item in assetsHistory" :key="item.id">
        <td>{{ item.user }}</td>
        <td>{{ item.dateAdded }}</td>
        <td>
          <p v-for="(log, index) in item.logs" :key="index" class="mb-0">{{ log.field }}</p>
        </td>
        <td>{{ item.action }}</td>
        <td>
          <p v-for="(log, index) in item.logs" :key="index" class="mb-0">
            <span v-if="log.newValue">{{ log.oldValue }} &#8594; </span>
            <span>{{ log.newValue || '' }}</span>
          </p>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import customAssets from "@/api/customAssets";

export default {
  name: 'CustomAssetsHistory',
  data() {
    return {
      customAssetId: null,
      assetsHistory: [],
      tableHistoryHeaders: [
        { name: 'User' },
        { name: 'Date/Time' },
        { name: 'Field' },
        { name: 'Action' },
        { name: 'Changes' },
      ],
    };
  },
  mounted() {
    this.customAssetId = this.$route.params.id;
    this.fetchAssetsHistory(this.customAssetId);
  },
  methods: {
    goBack() {
      this.$router.push(`/affiliates/customAssets/`);
    },
    async fetchAssetsHistory(customAssetsId) {
      try {
        const res = await customAssets.getCustomAssetsHistoryById(customAssetsId);
        this.assetsHistory = res.map(item => ({
          ...item,
          logs: JSON.parse(item.logs)
        }));
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
<style scoped>

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ccc;
}

th {
  background-color: #fcfcfc;
}
</style>
